import {INftType} from '~/types/token-type.type'
import type {ValueOf} from '~/types/value-of'

export const nftItemDetailPageTab = {
  transfers: 'transfers',
  holders: 'holders',
  inventory: 'inventory',
  'contract-code': 'contract-code',
}
export type nftItemDetailPageTab = ValueOf<typeof nftItemDetailPageTab>;

export const nftDetailPageTab = {
  ...nftItemDetailPageTab,
  info: 'info'
} as const
export type nftDetailPageTab = ValueOf<typeof nftDetailPageTab>;

export default {
  getLatestTradesPage: () => {
    return '/nfts/trades'
  },
  getLatestTransfersPage: () => {
    return '/nfts/transfers'
  },
  getLatestMintsPage: () => {
    return '/nfts/mints'
  },
  getNftDetailPageWithTab: (nftType: INftType, address: string, tab?: nftDetailPageTab) => {
    if (!tab) tab = nftDetailPageTab.transfers
    return `/nfts/${nftType.toLowerCase()}/${address}/${tab}`
  },
  getNftItemDetailPageWithTab: (nftType: INftType, address: string, tokenId: string, tab?: nftItemDetailPageTab) => {
    if (!tab) tab = nftItemDetailPageTab.transfers
    return `/nfts/${nftType.toLowerCase()}/${address}/${tokenId}/${tab}`
  },

  // isNftItemPage (path: string) {
  //   const regex = new RegExp(/^\/nfts\/.+\/.+\/.+\/(transfers|holders|inventory|contract-code|info)$/)
  //   return regex.test(path)
  // },
}